export default __webpack_public_path__ + "static/media/img11.f8948635.png";